import {Input, Label} from "reactstrap";
import external from "../../../../styles/assets/images/sv/external.svg";
import {t} from "i18next";
import {useInjection} from "brandi-react";
import {SubscriptionContainerModelToken} from "../../SubscriptionContainer/model";
import { observer } from 'mobx-react-lite';

const TERMS_UPDATE_CHECKPOINT = new Date('2026-02-01T00:00:00.000Z')

const SubscriptionsTermsPurchase = ({register, handelChange, errors}) => {
    const subscriptionContainerM = useInjection(SubscriptionContainerModelToken)
    const lastRecharge = subscriptionContainerM.payingUser?.last_recharge

    const dateLastRechargeUpdate = new Date(lastRecharge)
    const isTermsOutdated = TERMS_UPDATE_CHECKPOINT > dateLastRechargeUpdate

    if(!isTermsOutdated) return null

    return (
        <div className="checkout__input-wrapper  terms-purchase">
            <Input
                    type="checkbox"
                    id="termsPurchase"
                    name="termsPurchase"
                    innerRef={register({
                        required: true,
                    })}
                    onChange={handelChange}
            />
            <Label htmlFor="termsPurchase">
                <a href={t('subscriptions.termsPurchaseLink')} target="_blank"
                   rel="noopener noreferrer">
                    {t('subscriptions.termsPurchase')}<img src={external} alt=""/>
                </a>
            </Label>

            <span className={errors.termsPurchase ? "error-label" : "error-label d-none"}>
                {errors.termsPurchase?.type === "required" && t("subscriptions.termsPurchaseError")}
            </span>
        </div>
    )
}

export default observer(SubscriptionsTermsPurchase);